<div class="low-res-container">
    <div class="inside">
        <h1>{{ 'LowResolution.Content' | translate }}</h1>
    </div>
    <div>
        <button (click)="onDismissLowResMode()">Dismiss</button>
    </div>
</div>
